var Backbone, SupportMainContentWrapperView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SupportMainContentWrapperView = (function(superClass) {
  extend(SupportMainContentWrapperView, superClass);

  function SupportMainContentWrapperView() {
    return SupportMainContentWrapperView.__super__.constructor.apply(this, arguments);
  }

  SupportMainContentWrapperView.prototype.className = 'help-wizard-content';

  SupportMainContentWrapperView.prototype.initialize = function() {};

  SupportMainContentWrapperView.prototype.render = function(renderContents) {
    return renderContents(this.$el);
  };

  return SupportMainContentWrapperView;

})(Backbone.View);

module.exports = SupportMainContentWrapperView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvbWFpbl9jb250ZW50X3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvbWFpbl9jb250ZW50X3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsdUNBQUE7RUFBQTs7O0FBQUEsUUFBQSxHQUFXLE9BQUEsQ0FBUSxVQUFSOztBQUNYLFFBQVEsQ0FBQyxDQUFULEdBQWE7O0FBRVA7Ozs7Ozs7MENBQ0osU0FBQSxHQUFXOzswQ0FFWCxVQUFBLEdBQVksU0FBQSxHQUFBOzswQ0FFWixNQUFBLEdBQVEsU0FBQyxjQUFEO1dBQ04sY0FBQSxDQUFlLElBQUMsQ0FBQSxHQUFoQjtFQURNOzs7O0dBTGtDLFFBQVEsQ0FBQzs7QUFRckQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
